/** @format */

const token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
const literal = /\[([^]*?)\]/gm;

const globalMasks = {
	default: 'yyyy-MM-dd HH:mm:ss',
	shortDate: 'M/d/yy',
	mediumDate: 'MMM D, yyyy',
	longDate: 'MMMM d, yyyy',
	fullDate: 'DDDD, MMMM d, yyyy',
	isoDate: 'yyyy-MM-dd',
	isoDateTime: 'yyyy-MM-ddTHH:mm:ssZ',
	shortTime: 'HH:mm',
	mediumTime: 'HH:mm:ss',
	longTime: 'HH:mm:ss.SSS',
};
const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNames = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];
const monthNamesShort = shorten(monthNames, 3);
const dayNamesShort = shorten(dayNames, 3);
const defaultI18n = {
	dayNamesShort,
	dayNames,
	monthNamesShort,
	monthNames,
	amPm: ['am', 'pm'],
	DoFn(dayOfMonth) {
		return (
			dayOfMonth +
			['th', 'st', 'nd', 'rd'][
				dayOfMonth % 10 > 3 ? 0 : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10
			]
		);
	},
};
const globalI18n = assign({}, defaultI18n);
const pad = function (val, len) {
	if (len === 0) {
		len = 2;
	}
	val = String(val);
	while (val.length < len) {
		val = `0${val}`;
	}
	return val;
};
const formatFlags = {
	d(dateObj) {
		return String(dateObj.getDate());
	},
	dd(dateObj) {
		return pad(dateObj.getDate());
	},
	do(dateObj, i18n) {
		return i18n.DoFn(dateObj.getDate());
	},
	D(dateObj) {
		return String(dateObj.getDay());
	},
	DD(dateObj) {
		return pad(dateObj.getDay());
	},
	DDD(dateObj, i18n) {
		return i18n.dayNamesShort[dateObj.getDay()];
	},
	DDDD(dateObj, i18n) {
		return i18n.dayNames[dateObj.getDay()];
	},
	M(dateObj) {
		return String(dateObj.getMonth() + 1);
	},
	MM(dateObj) {
		return pad(dateObj.getMonth() + 1);
	},
	MMM(dateObj, i18n) {
		return i18n.monthNamesShort[dateObj.getMonth()];
	},
	MMMM(dateObj, i18n) {
		return i18n.monthNames[dateObj.getMonth()];
	},
	yy(dateObj) {
		return pad(String(dateObj.getFullYear()), 4).substr(2);
	},
	yyyy(dateObj) {
		return pad(dateObj.getFullYear(), 4);
	},
	h(dateObj) {
		return String(dateObj.getHours() % 12 || 12);
	},
	hh(dateObj) {
		return pad(dateObj.getHours() % 12 || 12);
	},
	H(dateObj) {
		return String(dateObj.getHours());
	},
	HH(dateObj) {
		return pad(dateObj.getHours());
	},
	m(dateObj) {
		return String(dateObj.getMinutes());
	},
	mm(dateObj) {
		return pad(dateObj.getMinutes());
	},
	s(dateObj) {
		return String(dateObj.getSeconds());
	},
	ss(dateObj) {
		return pad(dateObj.getSeconds());
	},
	S(dateObj) {
		return String(Math.round(dateObj.getMilliseconds() / 100));
	},
	SS(dateObj) {
		return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
	},
	SSS(dateObj) {
		return pad(dateObj.getMilliseconds(), 3);
	},
	a(dateObj, i18n) {
		return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
	},
	A(dateObj, i18n) {
		return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
	},
	ZZ(dateObj) {
		const offset = dateObj.getTimezoneOffset();
		return (offset > 0 ? '-' : '+') + pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4);
	},
	Z(dateObj) {
		const offset = dateObj.getTimezoneOffset();
		return `${(offset > 0 ? '-' : '+') + pad(Math.floor(Math.abs(offset) / 60), 2)}:${pad(Math.abs(offset) % 60, 2)}`;
	},
};
function shorten(arr, sLen) {
	const newArr = [];
	for (let i = 0, len = arr.length; i < len; i++) {
		newArr.push(arr[i].substr(0, sLen));
	}
	return newArr;
}
function assign(origObj) {
	const args = [];

	for (let _i = 1; _i < arguments.length; _i++) {
		args[_i - 1] = arguments[_i];
	}
	for (let _a = 0, args1 = args; _a < args1.length; _a++) {
		const obj = args1[_a];
		for (const key in obj) {
			// @ts-ignore ex
			origObj[key] = obj[key];
		}
	}
	return origObj;
}
const format = function (dateObj, mask, i18n) {
	if (dateObj === null || dateObj === undefined) return '';
	if (!mask) {
		mask = globalMasks['default'];
	}
	if (!i18n) {
		i18n = {};
	}
	if (typeof dateObj === 'number') {
		dateObj = new Date(dateObj);
	}
	if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
		throw new Error('Invalid Date pass to format', dateObj, mask);
	}
	mask = globalMasks[mask] || mask;
	const literals = [];
	mask = mask.replace(literal, function ($0, $1) {
		literals.push($1);
		return '@@@';
	});
	const combinedI18nSettings = assign(assign({}, globalI18n), i18n);
	mask = mask.replace(token, function ($0) {
		return formatFlags[$0](dateObj, combinedI18nSettings);
	});
	return mask.replace(/@@@/g, function () {
		return literals.shift();
	});
};
const fecha = {
	format,
};

export default fecha;
export { format };
